<script setup lang="ts">
import { useBrowserStore } from '@apps/main/new-desktop/core/stores';

import { AppFlicker } from '@libs/ui';

const browserStore = useBrowserStore();
</script>

<template>
  <header class="hotel-details-header-loader">
    <div class="header-title">
      <AppFlicker
        v-if="browserStore.isSmallerThan1200px"
        width="100%"
        height="font-size-h3"
        border-radius="border-radius-8"
      />
      <AppFlicker
        v-else
        width="100%"
        height="spacing-32"
        border-radius="border-radius-8"
      />
    </div>
    <AppFlicker
      width="spacing-96"
      height="font-size-h5"
      border-radius="border-radius-8"
    />
    <AppFlicker
      width="spacing-96"
      height="spacing-24"
      border-radius="border-radius-8"
    />
  </header>
</template>

<style scoped lang="scss">
.hotel-details-header-loader {
  display: flex;
  flex-flow: column;
  justify-content: space-between;
  gap: var(--spacing-8);
  padding-bottom: var(--spacing-16);

  .header-title {
    display: block;
    max-width: 70%;
  }
}
</style>
